import React from "react";
import s from "./style.module.css";
import Container from "../../Container";
import { ReactComponent as Logo } from "./logo.svg";

const Header = (props) => {
  return false;

  return (
    <header className={s.header}>
      <Container isLarge>
        <div className={s.container}>
          <a className={s.link} href="https://www.appcast.io/" target="blank">
            <Logo />{" "}
          </a>
        </div>
      </Container>
    </header>
  );
};

export default Header;
